import React from "react";
import styled from "@emotion/styled";
import logo from "./logo.png";
import { DesktopMainMenu, MenuLink } from "./styles";

const Div = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-width: 28%;
  word-break: keep-all;
  @media screen and (max-width: 1260px) {
    min-width: 45%;
  }
  @media screen and (max-width: 1055px) {
    /* min-width: 55%; */
  }
`;
const Connect = styled.div`
  cursor: pointer;
  background: linear-gradient(to right, #ff3ffd, #fed900);
  text-shadow: 2px 1px 12.9px #ec9dc1;
  background-size: cover;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  border-radius: 24px;
  padding: 10px 20px 10px 0px;
  font-family: "Lucida-Regular";
  font-size: 20px;
  opacity: 1;
  /* box-shadow: ${(props) =>
    props.bs ? props.bs : "inset 0px 2px 5px 0px white"}; */
  &:hover {
    /* color: #000; */
    opacity: 1;
  }
  @media screen and (max-width: 899px) {
    display: none;
  }
`;
const A = styled.a`
  text-decoration: none;
`;
const ConnectButton = styled.button``;
const DesktopMenu = (props) => {
  const menulist = props.menuList.map(function (value, i) {
    return (
      <MenuLink key={i} href={value[1]}>
        {value[0]}
      </MenuLink>
    );
  });
  return (
    <DesktopMainMenu maxWidth="xl">
      <MenuLink href="/">
        {/* <Image src={logo} width="300" height="86" layout="intrinsic" /> */}
      </MenuLink>
      <Div>
        {menulist}
        {/* <A
          href="https://app.uniswap.org/#/swap?outputCurrency=0xe36ac872eb1aefcf746feb6728b81b38fc6d75b2&chain=mainnet"
          target="blank"
        >
          <Connect>Buy/Sell</Connect>
        </A> */}
      </Div>
    </DesktopMainMenu>
  );
};

export default DesktopMenu;
